const MuiSelect = {
  styleOverrides: {
    filled: {
      paddingLeft: 24,
      paddingTop: 14,
    },
    iconOutlined: {
      right: 15,
    },
    outlined: {
      minHeight: '1.1876em',
    },
  },
};

export default MuiSelect;
